import { Alert, AlertIcon } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export const HiddenEntryDocumentationNotice = () => {
  const { t } = useTranslation();
  return (
    <Alert status="info" rounded="md" fontSize="sm" alignItems="flex-start">
      <AlertIcon />
      {t(
        "The documentation attached to the entry is hidden until the jury's decision is registered, as it may reveal who is behind the entry.",
      )}
    </Alert>
  );
};
